
export const StripePublicKeyMap: {[environment:string]: string} = {
    development: 'pk_test_51K4IL3KA8M9CmmC1u3pwUReVMskXQopqSRih9EOOmMs8Uz8vMqma0oOrnPKI2GvasqIO3QEdTwUQ3SWF8MuFMWJl00QRfj6T92',
    production: 'pk_live_51K4IL3KA8M9CmmC1AtMZN2FvyHz3S5WFUzmlSvOR5VKTJELRWjNDfnoxrbuvZRLs8zga51XYyedA129WXA5nkxST00sMB8sh78'
}